import { Component, OnInit, OnDestroy} from '@angular/core';
import { Subscription } from 'rxjs';

import { LoaderService } from './loader.service';
import { LoaderState } from './loader';


@Component({
    selector: 'app-loader',
    templateUrl: 'loader.component.html',
    standalone: false
})
export class LoaderComponent implements OnInit, OnDestroy {

  show = false;
  cssClass = 'loader-page-center-overlay';
  loaderClass = 'loader-overlay-panel';

  subscription: Subscription;
  constructor(
    private loaderService: LoaderService
  ) { }

  ngOnInit() {
    this.subscription = this.loaderService.loaderState
      .subscribe((state: LoaderState) => {
        this.show = state.show;
      });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
